"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AuthUserStore = /*#__PURE__*/function (_RootStore) {
  function AuthUserStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, AuthUserStore);
    _this = _callSuper(this, AuthUserStore);
    _this.config = {
      model: _models.User,
      deserialize: true,
      GET: {
        show: '/auth_user'
      },
      PUT: {
        update: '/auth_user',
        clearStoriesProgress: '/auth_user/clear_stories_progress',
        clearTriviaProgress: '/auth_user/clear_trivia_progress',
        clearVocabProgress: '/auth_user/clear_vocab_progress',
        clearGenderProgress: '/auth_user/clear_gender_progress',
        clearPluralProgress: '/auth_user/clear_plural_progress',
        clearNumberProgress: '/auth_user/clear_number_progress',
        clearConjugationProgress: '/auth_user/clear_conjugation_progress',
        addEasyGermanUserGroup: '/auth_user/add_easy_german_user_group',
        clearLeagueProgress: '/auth_user/clear_league_progress'
      },
      POST: {
        addXp: '/auth_user/add_xp',
        assignAffiliateCode: '/auth_user/assign_affiliate_code'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(AuthUserStore, _RootStore);
  return (0, _createClass2["default"])(AuthUserStore, [{
    key: "addXp",
    value: function addXp(params, callback) {
      this.api(params, callback, 'POST', 'addXp');
    }
  }, {
    key: "clearStoriesProgress",
    value: function clearStoriesProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearStoriesProgress');
    }
  }, {
    key: "clearTriviaProgress",
    value: function clearTriviaProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearTriviaProgress');
    }
  }, {
    key: "clearVocabProgress",
    value: function clearVocabProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearVocabProgress');
    }
  }, {
    key: "clearGenderProgress",
    value: function clearGenderProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearGenderProgress');
    }
  }, {
    key: "clearNumberProgress",
    value: function clearNumberProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearNumberProgress');
    }
  }, {
    key: "clearConjugationProgress",
    value: function clearConjugationProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearConjugationProgress');
    }
  }, {
    key: "clearPluralProgress",
    value: function clearPluralProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearPluralProgress');
    }
  }, {
    key: "assignAffiliateCode",
    value: function assignAffiliateCode(params, callback) {
      this.api(params, callback, 'POST', 'assignAffiliateCode');
    }
  }, {
    key: "addEasyGermanUserGroup",
    value: function addEasyGermanUserGroup(params, callback) {
      this.api(params, callback, 'PUT', 'addEasyGermanUserGroup');
    }
  }, {
    key: "clearLeagueProgress",
    value: function clearLeagueProgress(params, callback) {
      this.api(params, callback, 'PUT', 'clearLeagueProgress');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new AuthUserStore();